import { Level2Wrapper } from '../common/Level2Wrapper';
import { ImageList } from '../common/ImageList';
import { GenericSubSection } from '../common/GenericSubSection';
import { useLevel1SectionData } from '../../hooks/useLevel1Section';
import { useDashImages } from '../../hooks/useDashImages';

const generalSections = ['check_engine_light', 'abs_light', 'air_bag_light', 'any_other_lights_on'];

export const Dash = () => {
  const { subSections } = useLevel1SectionData('interior_questions');
  const images = useDashImages();

  return (
    <Level2Wrapper flex="1 1 100%" label="Dash">
      <ImageList label="Dash Pictures" images={images} />
      {generalSections.map(sectionKey => {
        const section = subSections[sectionKey];
        if (!section || !section.grade) return null;
        return <GenericSubSection key={sectionKey} section={subSections[sectionKey]} />;
      })}
    </Level2Wrapper>
  );
};
